/**
 * Development-only logging utility
 * Replaces console.log statements with conditional logging
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isLocalStack = process.env.REACT_APP_USE_LOCALSTACK === 'true';

// Enable logging in development OR LocalStack mode
const shouldLog = isDevelopment || isLocalStack;

export const logger = {
  debug: (...args) => {
    if (shouldLog) {
      console.log('[DEBUG]', ...args);
    }
  },

  info: (...args) => {
    if (shouldLog) {
      console.info('%c[INFO]', 'color: #2196F3; font-weight: bold', ...args);
    }
  },

  warn: (...args) => {
    if (shouldLog) {
      console.warn('[WARN]', ...args);
    }
  },

  error: (...args) => {
    // Always log errors, even in production
    console.error('%c[ERROR]', 'color: #f44336; font-weight: bold', ...args);
  },

  // For debugging data structures
  table: data => {
    if (shouldLog && console.table) {
      console.table(data);
    }
  },

  // For performance timing
  time: label => {
    if (shouldLog) {
      console.time(label);
    }
  },

  timeEnd: label => {
    if (shouldLog) {
      console.timeEnd(label);
    }
  },
};

// Convenience function for form debugging
export const logFormData = (formData, label = 'Form Data') => {
  if (!shouldLog) return;

  logger.debug(`${label}:`);
  for (const pair of formData.entries()) {
    logger.debug(`  ${pair[0]}: ${pair[1]}`);
  }
};
